export default [
	{
		name: "VERSAO",
		value: "Versão",
	},{
		name: "ACAO",
		value: "Ação",
	},{
		name: "CNS",
		value: "Cns",
	},{
		name: "INDICEREGISTRO",
		value: "Índice", 
	},{
		name: "NOMEREGISTRADO",
		value: "Nome do Registrado", 
	},{
		name: "CPFREGISTRADO",
		value: "CPF do Registrado", 
	},{
		name: "MATRICULA",
		value: "Matrícula",
	},{
		name: "DATAREGISTRO",
		value: "Data do Registro",
	},{
		name: "DNV",
		value: "Dnv",
	},{
		name: "DATANASCIMENTO",
		value: "Data do Nascimento",
	},{
		name: "HORANASCIMENTO",
		value: "Hora do Nascimento",
	},{
		name: "LOCALNASCIMENTO",
		value: "Local do Nascimento",
	},{
		name: "SEXO",
		value: "Sexo",
	},{
		name: "POSSUIGEMEOS",
		value: "Possui Gêmeos",
	},{
		name: "NUMEROGEMEOS",
		value: "Número de Gêmeos",
	},{
		name: "CODIGOIBGEMUNNASCIMENTO",
		value: "Cod. IBGE Município do Nascimento", 
	},{
		name: "PAISNASCIMENTO",
		value: "País", 
	},{
		name: "NACIONALIDADE",
		value: "Nacionalidade", 
	},{
		name: "TEXTONACIONALIDADEESTRANGEIRO",
		value: "Texto Nacionalidade Estrangeiro",
	},{
		name: "FILIACAONASCIMENTO",
		value: "Filiação Nascimento",
	},{
		name: "INDICEFILIACAO",
		value: "Índice da Filiação",
	},{
		name: "NOME",
		value: "Nome",
	},{
		name: "SEXO",
		value: "Sexo",
	},{
		name: "CPF",
		value: "Cpf",
	},{
		name: "IDADE",
		value: "Idade",
	},{
		name: "IDADE_DIAS_MESES_ANOS",
		value: "Idade Dias Meses Anos",
	},{
		name: "CODIGOIBGEMUNLOGRADOURO",
		value: "Cod. IBGE Município Logradouro",
	},{
		name: "LOGRADOURO",
		value: "Logradouro",
	},{
		name: "NUMEROLOGRADOURO",
		value: "Número do Logradouro",
	},{
		name: "COMPLEMENTOLOGRADOURO",
		value: "Complemento do Logradouro",
	},{
		name: "BAIRRO",
		value: "Bairro",
	},{
		name: "NACIONALIDADE",
		value: "Nacionalidade",
	},{
		name: "DOMICILIOESTRANGEIRO",
		value: "Domicílio Estrangeiro",
	},{
		name: "CODIGOIBGEMUNNATURALIDADE",
		value: "Cod. IBGE Município Naturalidade",
	},{
		name: "TEXTOLIVREMUNICIPIONAT",
		value: "Texto Livre Município Naturalidade", 
	},{
		name: "CODIGOOCUPACAOSDC",
		value: "Código Ocupação SDC",
	},{
		name: "DOCUMENTOS",
		value: "Documentos", 
	},{
		name: "DONO",
		value: "Dono", 
	},{
		name: "TIPO_DOC",
		value: "Tipo de Documento",
	},{
		name: "DESCRICAO",
		value: "Descrição",
	},{
		name: "NUMERO",
		value: "Número",
	},{
		name: "NUMERO_SERIE",
		value: "Número de Série",
	},{
		name: "CODIGOORGAOEMISSOR",
		value: "Cod. Orgão Emissor", 
	},{
		name: "UF_EMISSAO",
		value: "UF Emissão",
	},{
		name: "DATA_EMISSAO",
		value: "Data Emissão",
	},{
		name: "ORGAOEMISSOREXTERIOR",
		value: "Orgão Emissor Exterior",
	},{
		name: "INFORMACOESCONSULADO",
		value: "Informações do Consulado",
	},{
		name: "OBSERVACOES",
		value: "Observações",
	}
]